export const SUPPORTS_ARRAY_PROTOTYPE_SPLICE = "splice" in Array.prototype;
